import {
  ArcadeIcon,
  CasinoIcon,
  FishingIcon,
  LotteryIcon,
  SlotsIcon,
  SportsBookIcon,
} from "./Icon2";
import {
  AmigoIcon,
  AvataruxIcon,
  BgamingIcon,
  BtgIcon,
  DeIcon,
  EnIcon,
  EsIcon,
  EvolutionIcon,
  FacebookIcon,
  FbIcon,
  FrIcon,
  HacksawIcon,
  InstagramIcon,
  LineIcon,
  LinkedinIcon,
  NolimitIcon,
  PlaynGoIcon,
  PocketGameIcon,
  PopiplayIcon,
  PragmaticIcon,
  PushgamingIcon,
  RedtigerIcon,
  RelaIcon,
  ShuffleIcon,
  TelegramIcon,
  TwitterIcon,
} from "./Icons";

import HeroSliderImg1 from "./../../assets/images/webp/herosliderimg1.webp";
import HeroSliderImg2 from "./../../assets/images/webp/herosliderimg2.webp";
import HeroSliderImg4 from "./../../assets/images/webp/herosliderimg4.webp";

import slotsImg1 from "./../../assets/images/png/slotsImg1.png";
import slotsImg2 from "./../../assets/images/png/slotsImg2.png";
import slotsImg3 from "./../../assets/images/png/slotsImg3.png";
import slotsImg4 from "./../../assets/images/png/slotsImg4.png";
import slotsImg5 from "./../../assets/images/png/slotsImg5.png";
import slotsImg6 from "./../../assets/images/png/slotsImg6.png";

import PopGameImg1 from "./../../assets/images/png/popGameImg1.png";
import PopGameImg2 from "./../../assets/images/png/popGameImg2.png";
import PopGameImg3 from "./../../assets/images/png/popGameImg3.png";
import PopGameImg4 from "./../../assets/images/png/popGameImg4.png";
import PopGameImg5 from "./../../assets/images/png/popGameImg5.png";
import PopGameImg6 from "./../../assets/images/png/popGameImg6.png";

import CasinoImg1 from "./../../assets/images/png/CasinoImg1.png";
import CasinoImg2 from "./../../assets/images/png/CasinoImg2.png";
import CasinoImg3 from "./../../assets/images/png/CasinoImg3.png";
import CasinoImg4 from "./../../assets/images/png/CasinoImg4.png";
import CasinoImg5 from "./../../assets/images/png/CasinoImg5.png";

import marruecosFla from "./../../assets/images/svg/marruecosFla.svg";
import polandFla from "./../../assets/images/svg/polandFla.svg";
import greeceFlg from "./../../assets/images/svg/greeceFlg.svg";
import slovakiaFlg from "./../../assets/images/svg/slovakiaFlg.svg";
import spanishFlg from "./../../assets/images/svg/spanishFlg.svg";

import articalImg1 from "./../../assets/images/png/articalImg1.png";
import articalImg2 from "./../../assets/images/png/articalImg2.png";
import articalImg3 from "./../../assets/images/png/articalImg3.png";
import SlotTabContent from "../pages/home/SlotTabContent";

import CasinoTabContent from "../pages/home/CasinoTabContent";
import LotteryTabContent from "../pages/home/LotteryTabContent";
import ArcadeTabContent from "../pages/home/ArcadeTabContent";
import SportsbookTabContent from "../pages/home/SportsbookTabContent";
import FishingTabContent from "../pages/home/FishingTabContent";

import ViewAllImg from "./../../assets/images/png/viewallimg.png";

export const heroSliderdata = [
  { img: HeroSliderImg1 },
  { img: HeroSliderImg2 },
  { img: HeroSliderImg1 },
  { img: HeroSliderImg4 },
];
export const tabsData = [
  {
    label: "Slots",
    icon: <SlotsIcon />,
    content: <SlotTabContent />,
  },
  {
    label: "Casino",
    icon: <CasinoIcon />,
    content: <CasinoTabContent />,
  },
  {
    label: "Lottery",
    icon: <LotteryIcon />,
    content: <LotteryTabContent />,
  },
  {
    label: "Sportsbook",
    icon: <SportsBookIcon />,
    content: <SportsbookTabContent />,
  },
  {
    label: "Fishing",
    icon: <FishingIcon />,
    content: <FishingTabContent />,
  },
  {
    label: "Arcade",
    icon: <ArcadeIcon />,
    content: <ArcadeTabContent />,
  },
];

export const SlotTabData = [
  {
    img: slotsImg1,
    headingpart1: "Kill by",
    headingpart2: "an alien",
    pera: "Clutch Games",
    bgColor: "#007BFF",
  },
  {
    img: slotsImg2,
    headingpart1: "Kill by",
    headingpart2: "an alien",
    pera: "Clutch Games",
    bgColor: "#FF7A00",
  },
  {
    img: slotsImg3,
    headingpart1: "Kill by",
    headingpart2: "an alien",
    pera: "Clutch Games",
    bgColor: "#FF008A",
  },
  {
    img: slotsImg4,
    headingpart1: "explore the",
    headingpart2: "house",
    pera: "Clutch Games",
    bgColor: "#FF003D",
  },
  {
    img: slotsImg5,
    headingpart1: "robot hunter",
    headingpart2: "rose",
    pera: "Clutch Games",
    bgColor: "#00B2FF",
  },
  {
    img: slotsImg6,
    headingpart1: "kILL sound",
    headingpart2: "receivers",
    pera: "Clutch Games",
    bgColor: "#53DA00",
  },
  {
    img: ViewAllImg,
    headingpart1: "",
    headingpart2: "",
    pera: "",
    bgColor: "",
  },
];

export const PopGameSlotData = [
  {
    img: PopGameImg1,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#007BFF",
  },
  {
    img: PopGameImg2,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#4200FF",
  },
  {
    img: PopGameImg3,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "##F00",
  },
  {
    img: PopGameImg4,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#FFA800",
  },
  {
    img: PopGameImg5,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#03A3FF",
  },
  {
    img: PopGameImg6,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#FF006B",
  },
  {
    img: ViewAllImg,
    headingpart1: "",
    headingpart2: "",
    pera: "",
    bgColor: "",
  },
];
export const CasinoSlotData = [
  {
    img: CasinoImg1,
    headingpart1: "blackjack",
    headingpart2: "eight8",
    pera: "",
    bgColor: "#E22BCF",
  },
  {
    img: CasinoImg2,
    headingpart1: "Lighting",
    headingpart2: "Roulette",
    pera: "",
    bgColor: "#F4881F",
  },
  {
    img: CasinoImg3,
    headingpart1: "Lighting",
    headingpart2: "roleta",
    pera: "",
    bgColor: "#03A3FF",
  },
  {
    img: CasinoImg4,
    headingpart1: "CRAZY",
    headingpart2: "TIMES",
    pera: "",
    bgColor: "#FE1101",
  },
  {
    img: CasinoImg5,
    headingpart1: "mega",
    headingpart2: "roulette",
    pera: "",
    bgColor: "#F93F47",
  },
  {
    img: CasinoImg1,
    headingpart1: "blackjack",
    headingpart2: "eight8",
    pera: "",
    bgColor: "#E22BCF",
  },
  {
    img: ViewAllImg,
    headingpart1: "",
    headingpart2: "",
    pera: "",
    bgColor: "",
  },
];
export const LotteryUpcomingData = [
  {
    img: marruecosFla,
    heading: "Marruecos Keno",
    run: "20/80",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#A2823C",
  },
  {
    img: polandFla,
    heading: "Poland Keno",
    run: "20/70",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#A13D68",
  },
  {
    img: greeceFlg,
    heading: "Greece KENO",
    run: "20/80",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#557098",
  },
  {
    img: slovakiaFlg,
    heading: "Slovakia EKIub Keno",
    run: "20/28",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#2EA64B",
  },
  {
    img: spanishFlg,
    heading: "Spanish Express",
    run: "20/70",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#DF5477",
  },
  {
    img: slovakiaFlg,
    heading: "Slovakia EKIub Keno",
    run: "20/28",
    price: "USDT 298,674.28",
    pera: "Next Draw Starts in",
    hh: "00",
    mm: "00",
    ss: "00",
    bgColor: "#2EA64B",
  },
];
export const ArticalData = [
  {
    img: articalImg1,
    heading: "HOW DO ONLINE SLOT MACHINES WORK?",
    pera: "Many punters prefer to wager on online slots because of their simplicity—you don’t need to be so skilled to spin reels. No wonder online slot gambling is a fast-growing industry that has generated more than 60% of revenue for the gambling industry.",
    date: "22 August, 2024",
  },
  {
    img: articalImg2,
    heading: "BLACKJACK FAQ",
    pera: "Many punters prefer to wager on online slots because of their simplicity—you don’t need to be so skilled to spin reels. No wonder online slot gambling is a fast-growing industry that has generated more than 60% of revenue for the gambling industry.",
    date: "22 August, 2024",
  },
  {
    img: articalImg3,
    heading: "HOW DO ONLINE SLOT MACHINES WORK?",
    pera: "Many punters prefer to wager on online slots because of their simplicity—you don’t need to be so skilled to spin reels. No wonder online slot gambling is a fast-growing industry that has generated more than 60% of revenue for the gambling industry.",
    date: "22 August, 2024",
  },
  {
    img: articalImg1,
    heading: "HOW DO ONLINE SLOT MACHINES WORK?",
    pera: "Many punters prefer to wager on online slots because of their simplicity—you don’t need to be so skilled to spin reels. No wonder online slot gambling is a fast-growing industry that has generated more than 60% of revenue for the gambling industry.",
    date: "22 August, 2024",
  },
  {
    img: articalImg2,
    heading: "BLACKJACK FAQ",
    pera: "Many punters prefer to wager on online slots because of their simplicity—you don’t need to be so skilled to spin reels. No wonder online slot gambling is a fast-growing industry that has generated more than 60% of revenue for the gambling industry.",
    date: "22 August, 2024",
  },
];
export const ProviderData = [
  {
    icon: <EvolutionIcon />,
  },
  {
    icon: <BgamingIcon />,
  },
  {
    icon: <NolimitIcon />,
  },
  {
    icon: <PragmaticIcon />,
  },
  {
    icon: <PushgamingIcon />,
  },
  {
    icon: <ShuffleIcon />,
  },
  {
    icon: <PlaynGoIcon />,
  },
  {
    icon: <BtgIcon />,
  },
  {
    icon: <HacksawIcon />,
  },
  {
    icon: <RelaIcon />,
  },
  {
    icon: <PopiplayIcon />,
  },
  {
    icon: <AvataruxIcon />,
  },
  {
    icon: <AmigoIcon />,
  },
  {
    icon: <RedtigerIcon />,
  },
  {
    icon: <PocketGameIcon />,
  },
];
export const SocialmediaData = [
  { icon: <FacebookIcon />, link: "https://fb.com" },
  { icon: <LinkedinIcon />, link: "https://linkedin.com" },
  { icon: <InstagramIcon />, link: "https://instagram.com" },
  { icon: <TwitterIcon />, link: "https://x.com" },
];
export const footerCompanyLinkData = [
  { title: "Home", link: "/" },
  { title: "About", link: "/" },
  { title: "Games", link: "/" },
  { title: "Pricing", link: "/" },
];
export const footerSupportLinkData = [
  { title: "Faq", link: "/" },
  { title: "Contact Us", link: "/" },
  { title: "Our Team", link: "/" },
  { title: "Testimonial", link: "/" },
];
export const footerPrivacyLinkData = [
  { title: "Security", link: "/" },
  { title: "Terms", link: "/" },
  { title: "Privacy", link: "/" },
];
export const contactLinkData = [
  {
    icon: <LineIcon />,
    title: "Line",
    link: "https://line.me/",
    linkTitle: "Atomgaming88",
  },
  {
    icon: <TelegramIcon />,
    title: "TELEGRAM",
    link: "https://t.me/Atomgaming88",
    linkTitle: "@Atomgaming88",
  },
  {
    icon: <FbIcon />,
    title: "Line",
    link: "https://fb.com/",
    linkTitle: "@Atomgaming88",
  },
];
export const HomeAboutData = [
  {
    mainHeading:
      "Casino Online Gaming Platform with a Legitimate Reputation for a Long Time",
    heading: "",
    pera: [
      "Online gaming is currently dominating all games available on Android and iOS. INVESTOTO is one of the most reputable online gaming investments that has been around for a long time, providing entertainment and substantial profits to many members.",
      "The online gaming platform at INVESTOTO has the fastest and most reliable servers, which enhance the gaming experience and allow for quick wins. INVESTOTO’s reputation is also well-established as a White-label site because it collaborates with top game producers.",
    ],
  },
  {
    mainHeading: "",
    heading: "Why Choose the INVESTOTO Site?",
    pera: [
      "Playing on the INVESTOTO site is like being at home; it offers a variety of games that make it easy to earn rewards. INVESTOTO’s game offerings are diverse and highly beneficial for game enthusiasts in Indonesia.",
      "Choosing INVESTOTO is a great decision, with so many games available that players won’t get bored. You can easily switch between your favorite games and play them.",
    ],
  },
  {
    mainHeading: "",
    heading: "Mahjong Ways Game Agent in Indonesia",
    pera: [
      "Having an online gaming site is advantageous for players, as it allows them to increase their income. One of the most popular games, for example, is Mahjong Ways, a game known for its simplicity and high potential for big wins.",
      "Playing with the online slot agent INVESTOTO has proven successful for many members who have earned substantial income. Mahjong Ways is famous for its large scatter bonuses, which can leave members amazed after winning big jackpots at INVESTOTO.",
    ],
  },
  {
    mainHeading: "",
    heading:
      "The Most Complete Deposit Website for Dana, QRIS, Transfers, and E-Money",
    pera: [
      "Technological advancements have made financial transactions easier and more practical. The INVESTOTO website also provides the fastest deposit transaction methods using these advanced technologies.",
    ],
  },
  {
    mainHeading: "",
    heading: "",
    pera: [
      "Depositing on INVESTOTO is very easy; users just choose the deposit method they prefer from the available options. One of the popular deposit methods among users is using QRIS, which is also automated and very fast. So, all INVESTOTO members can rest assured, as everything here is highly advantageous.",
    ],
  },
];
export const languages = [
  {
    code: "en",
    name: "English",
    icon: <EnIcon />,
  },
];
